module.exports = __webpack_public_path__ + "img/logo-dark.3d119b09.png";